<!-- Sidebar semantica -->
<aside id="sidebar">
  @if (userService.currentUser(); as user) {
    <div class="studio-container">
      <span class="caption"><strong>{{ user!.commInfo.commercialista }}</strong></span>
      <span class="caption">{{ user!.commInfo.testoLibero }}</span>
      <span class="caption">{{ user!.commInfo.indirizzo }}</span>
      <span class="caption">{{ user!.commInfo.cap }} - {{ user!.commInfo.citta }} ({{ user!.commInfo.provincia }})</span>
    </div>
  }

  <nav aria-label="Menu laterale">
    <ul>
      @for (item of menuService.filteredMenu(); track item.id) {
        <li
          [class.active]="item.isActive"
          [class.no-submenu]="!(item.children?.length)"
          [class.has-submenu]="!!(item.children?.length)"
          [class.active-parent]="item.isActiveParent"
        >
          <button class="label-small" (click)="onMenuItemClick(item)">
            {{ item.label }}
            @if (item.children?.length) {
              <img
                class="dropdown-arrow"
                [class.reverse]="item.isExpanded"
                ngSrc="/icon/dropdown-arrow.svg"
                alt=""
                width="12"
                height="12"
              >
            }
          </button>

          @if (( item.children?.length ) && item.isExpanded) {
            <ul class="submenu">
              @for (child of item.children; track child.id) {
                <li
                  [class.active]="child.isActive"
                  [class.no-submenu]="!(child.children?.length)"
                  [class.has-submenu]="!!(child.children?.length)"
                  [class.active-parent]="child.isActiveParent"
                >
                  <button class="caption" (click)="onMenuItemClick(child)">
                    @if (child.children?.length) {
                      <img
                        class="dropdown-arrow"
                        [class.reverse]="child.isExpanded"
                        ngSrc="/icon/dropdown-arrow.svg"
                        alt=""
                        width="12"
                        height="12"
                      >
                    }
                    {{ child.label }}
                  </button>

                  @if (( child.children?.length ) && child.isExpanded) {
                    <ul class="submenu">
                      @for (sub of child.children; track sub.id) {
                        <li
                          [class.active]="sub.isActive"
                          [class.no-submenu]="!(sub.children?.length)"
                          [class.has-submenu]="!!(sub.children?.length)"
                          [class.active-parent]="sub.isActiveParent"
                        >
                          <button class="caption-small" (click)="onMenuItemClick(sub)">
                            {{ sub.label }}
                          </button>
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </nav>
</aside>
